import Text from 'components/Text/Text';
import React from 'react';
import { IItemRestaurantDevice } from 'types';
import TerminalsList from './components/TerminalsList';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemRestaurantDevice;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const hardwareIdHeadingClasses = classNames(style.hardwareId, style.row);
	const terminalIdHeadingClasses = classNames(style.terminalId, style.row);
	const tableNumberHeadingClasses = classNames(style.tableNumber, style.row);

	return (
		<div data-test={`Item-${index}`}>
			<div className={style.container}>
				<Text className={hardwareIdHeadingClasses} translationKey={data.hardwareId} withTooltip={true} />
				<div className={terminalIdHeadingClasses}>
					<TerminalsList data={data.terminalIds} />
				</div>
				<Text className={tableNumberHeadingClasses} translationKey={data.tableName} withTooltip={true} />
			</div>
		</div>
	);
};

export default Item;
